export const leagues = [
  {
    id: 4328,
    name: 'Premier League',
    logo:
      'https://upload.wikimedia.org/wikipedia/en/thumb/f/f2/Premier_League_Logo.svg/1920px-Premier_League_Logo.svg.png',
    shortHand: 'epl',
    div: 'E0',
  },
  {
    id: 4335,
    name: 'La Liga',
    logo:
      'https://upload.wikimedia.org/wikipedia/commons/thumb/9/92/LaLiga_Santander.svg/1024px-LaLiga_Santander.svg.png',
    shortHand: 'laliga',
    div: 'SP1',
  },
  {
    id: 4331,
    name: 'Bundesliga',
    logo:
      'https://upload.wikimedia.org/wikipedia/en/thumb/d/df/Bundesliga_logo_%282017%29.svg/1024px-Bundesliga_logo_%282017%29.svg.png',
    shortHand: 'bundesliga',
    div: 'D1',
  },
  {
    id: 4332,
    name: 'Serie A',
    logo:
      'https://upload.wikimedia.org/wikipedia/en/thumb/e/e1/Serie_A_logo_%282019%29.svg/800px-Serie_A_logo_%282019%29.svg.png',
    shortHand: 'seria',
    div: 'I1',
  },
  {
    id: 4334,
    name: 'French Ligue 1',
    logo:
      'https://upload.wikimedia.org/wikipedia/en/thumb/b/ba/Ligue_1_Uber_Eats.svg/800px-Ligue_1_Uber_Eats.svg.png',
    shortHand: 'ligue1',
    div: 'F1',
  },
  {
    name: 'Eredivisie',
    logo:
      'https://upload.wikimedia.org/wikipedia/commons/thumb/0/0f/Eredivisie_nieuw_logo_2017-.svg/1920px-Eredivisie_nieuw_logo_2017-.svg.png',
    shortHand: 'eredivisie',
    div: 'N1',
  },
];
